export default __webpack_public_path__ + "static/media/bed10.e00e6054.png";